import React, { Component } from 'react';
import { withStyles  } from '@mui/styles';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import PlacementBasicForm from './PlacementBasicForm';
import PlacementToolbar from './PlacementToolbar';
import PlacementValidationRules from './ValidationRules';
import RatesAndDates from './RatesandDates';
import Targeting from '../../containers/placement/Targeting';
import AdManagerView from './AdManagerView';
import ErrorPage from '../../errors/ErrorPage';
import Geotargets from '../../containers/placement/Geotargets';
import { validate } from '../../utils/formValidator';
import { computeTotalContractAmount } from '../../utils/totalContractAmount';
import {
  hasMixedVideoAndNonVideoProducts,
  mixedVideoAndNonVideoMessage
} from '../../utils/creativeProductValidation';
import { TrackingCtx  } from '../../tracking.js';

const styles = theme => ({
  root: {
    overflow: "scroll",
    padding: 20,
    backgroundColor: '#eeeeee'
  },
  leftIcon: {
    marginRight: theme.spacing(2)
  }
});


class PlacementPage extends Component {

  constructor(props) {
    super(props);
    let placement;
    if (props.location.pathname.includes('create') || isEmpty(props.placement)) {
      placement = this.buildPlacement(props);
    } else {
      placement = props.placement;
    }
    const pkg = this.doPackage(props, placement);
    this.placementValidationRules = PlacementValidationRules(props.order);
    this.state = {
      placement: placement,
      errors: {},
      innerHeight: window.innerHeight,
      pkg: pkg,
      packageId: parseInt(props.packageId, 10)
    }
  }

  componentDidMount() {
    const { ioId } = this.props;
    const { placement } = this.state;
    if (!placement.IoId) {
      placement.IoId = ioId;
    }
    window.addEventListener('resize', this.handleResize);

    const p1 = Object.assign({}, placement);
    const pkg = this.doPackage(this.props, p1);
    this.setState({
      placement: p1,
      pkg: pkg,
      packageId: parseInt(this.props.packageId, 10)
    });

    this.props.onLoad(placement);
  }

  componentDidUpdate(prev) {
    if (isEmpty(prev.order) && !isEmpty(this.props.order)) {
      const p1 = Object.assign({}, this.state.placement);
      const pkg = this.doPackage(this.props, p1);
      this.setState({
        placement: p1,
        pkg: pkg,
        packageId: parseInt(this.props.packageId, 10)
      });
    }
    if (!this.props.location.pathname.includes('create')) {
      if ((isEmpty(prev.placement) || !prev.placement.id) && !!this.props.placement.id) {
        this.updatePlacement();
      }
    }
  }

  doPackage = (props, placement) => {
    let pkgId;
    if (placement && placement.packageId) {
      pkgId = placement.packageId;
    } else {
      pkgId = parseInt(props.packageId, 10);
    }
    if (!pkgId || isEmpty(props.order)) {
      return null;
    }
    const pkg = props.order.Packages.find(pkg => pkg.id === pkgId);
    if (pkg) {
      pkg.plCount = props.order.Placements.filter(pl => pl.packageId === pkgId).length;
      this.placementValidationRules = PlacementValidationRules(props.order, pkg);
    } else {
      return pkg;
    }
    try {
      if (isEmpty(props.placement)) {
        pkg.plCount += 1;
      }
    } catch (e) {
      console.log('Error in doPackage', e.message, pkgId, props.placement);
    }
    const { startDate, endDate } = this.getDates(props);
    placement.start = startDate;
    placement.end = endDate;
    placement.agencyPackageName = pkg.name;
    placement.ioRate = pkg.rate;
    placement.contractedQuantity = pkg.contractedQuantity / pkg.plCount;
    placement.totalContractedAmount = (placement.ioRate * placement.contractedQuantity) / 1000;
    placement.packageId = pkg.id;
    return pkg;
  };

  getDates = (props) => {
    let startDate = moment();
    let endDate = moment();
    if (isEmpty(props.order)) {
      return { startDate, endDate };
    }
    if (props.packageId) {
      const pkgId = parseInt(props.packageId, 10);
      const pkgPlacements = props.order.Placements.filter(p => p.packageId === pkgId);
      if (!isEmpty(pkgPlacements)) {
        startDate = pkgPlacements.reduce((m, p) => m < p.start ? m : p.start, pkgPlacements[0].start);
        endDate = pkgPlacements.reduce((m, p) => m > p.end ? m : p.end, pkgPlacements[0].end);
      }
    } else {
      startDate = moment(props.order.start);
      endDate = moment(props.order.end);
    }
    return { startDate, endDate };
  }

  /*********************************
   * Create empty placement
   * @param props - contains order for id and date
   * @returns created placement object
   ********************************/
  buildPlacement = (props) => {
    return {
      dfpLineItemId: null,
      agencyPackageName: '',
      agencyPlacementName: '',
      agencyPlacementId: '',
      agencyBillingId: '',
      billingGroup: '',
      comments: '',
      gComments: '',
      start: moment(),
      end: moment(),
      ioRate: 0,
      contractedQuantity: 1,
      totalContractAmount: 0,
      Geotargets: [],
      excludedGeotargetIds: [],
      geogroups: [],
      geoGlobal: false,
      Pubs: [],
      saveIncomplete: 0,
      pubSelect: false,
      targetLanguage: 'English',
      creativePremiumPercent: 0,
      effectiveRate: 0,
      viewability: '',
      IoId: props.order ? props.order.id : 0,
      IoRateTypeId: 1,
      IoRateType: props.constants ? props.constants.ioRateTypes[0] : { id: 1, name: 'CPM' },
      SalesProductId: 0,
      SalesProduct: {},
      StrategyId: 0,
      Strategy: {},
      DeviceTypes: [],
      DataFees: [],
      CustomCriteriaPresets: [],
      CreativeProducts: [],
      LineItemSettings:{},
      lineItemType: 'STANDARD',
      exclusions: [],
      packageType: props.order ? props.order.packageType : '',
    };
  }

  handleResize = () => {
    this.setState({ innerHeight: window.innerHeight });
  };

  updatePlacement = () => {
    this.setState({ placement: this.props.placement });
  };

  save = () => {
    this.savePlacement(this.props.onBack);
  };

  saveAndNext = () => {
    this.savePlacement(this.props.onNext);
  };

  saveAndPrior = () => {
    this.savePlacement(this.props.onPrior);
  };

  saveAndDone = () => {
    this.savePlacement(this.props.onDone);
  };

  saveAndNew = () => {
    this.savePlacement(this.props.onNew);
  };

  savePlacement = sideEffect => {
    const { placement } = this.state;
    const errors = this.validatePlacement(placement);
    placement.pubs = placement.Pubs;
    if (isEmpty(errors)) {
      placement.saveIncomplete = 0;
      this.props.onSave(placement, sideEffect);
    } else {
      this.setState({ errors });
      this.props.onValidationError(errors);
    }
  };

  validatePubs = () => {
    const error = {};
    const { placement } = this.state;
    let spName = placement && placement.SalesProduct ? placement.SalesProduct.name : 'XXXX';
    if (!spName) {
      spName = 'XXXX';
    }
    if  (placement && placement.Strategy && placement.Strategy.name === 'Aura TV Preroll') {
      return error;
    }
    if ((spName.slice(0, 3) === 'HDM' || spName.slice(0, 4) === 'CDRT' ||
      spName === 'Hearst O&O Inventory' || spName === 'Custom') &&
      placement && placement.Pubs && placement.Pubs.length === 0) {
      error.Pubs = 'Publisher is a required field for this Sales Product';
    }
    return error;
  };

  validatePresets = () => {
    const error = {};
    const { placement } = this.state;
    const { constants } = this.props;
    if (placement.Strategy && placement.Strategy.name === 'Suggestive' &&
      placement.SalesProduct && placement.SalesProduct.name === 'JAG Awareness') {
      return error;
    }
    console.log('strategy', placement.Strategy);
    console.log('validate presets', placement);
    let strategyDetails;
    if (placement.Strategy
      && constants.strategyRequiresDetails.indexOf(placement.Strategy.RequiredDetailTypeId) !== -1
      && placement.CustomCriteriaPresets.length === 0) {
      console.log('strategy', placement.Strategy);
      strategyDetails = placement.Strategy.RequiredDetailTypeId;
      console.log('details', strategyDetails);
      console.log('customCriteria', placement.CustomCriteriaPresets);
      error.CustomCriteriaPresets = 'Details are required for selected strategy';
    }
    return error;
  };

  validateCreativeProducts = () => {
    const error = {};
    const { placement } = this.state;
    const { deviceTypes, creativeProducts, constants } = this.props;
    const deletedCreatives = placement.CreativeProducts.filter(cp => cp.deletedAt);
    if (deletedCreatives.length > 0) {
      console.log('deletedCreatives', deletedCreatives);
      error.CreativeProducts = `deleted${deletedCreatives}`;
      return error;
    }
    console.log('creativeProducts', creativeProducts);
    const wantedDevices = deviceTypes.filter(deviceType => deviceType.id !== 9).map(deviceType => deviceType.name);
    console.log('wanted devices', deviceTypes);
    let foundProducts = [];
    foundProducts = creativeProducts.map(cp => cp.DeviceTypes);
    console.log('found products', foundProducts);
    const devicesFoundSet = new Set(foundProducts);
    const devicesWantedSet = new Set(wantedDevices);
    creativeProducts.forEach(pcp => {
      foundProducts.concat(pcp.DeviceTypes);
    });
    console.log('found products', foundProducts);
    console.log('wanted', devicesWantedSet);
    const df = (devicesWantedSet.difference(devicesFoundSet));
    const dw= (devicesFoundSet.difference(devicesWantedSet));
    const dwx = [...dw];
    const dfx = [...df];
    console.log('dwx, dfx', dwx.length, dfx.length);
    if (dwx.length > 0 || dfx.length > 0) {
      console.log('Device types do not match creative products');
      // error.CreativeProducts = 'Device types do not match creative products';
    }
    if (placement.SalesProduct.name === 'Predictive Intenders Package') {
      const hasHDM = placement.CreativeProducts.some(cp => cp.name.includes('HDM'));
      const hasSTD = placement.CreativeProducts.some(cp => cp.name.includes('STD'));
      if (!hasHDM || !hasSTD) {
        error.CreativeProducts = `PIP sales product needs both an HDM and a STD creative`;
      }
    }
    if (hasMixedVideoAndNonVideoProducts(placement.CreativeProducts, constants.videoProducts)) {
      error.CreativeProducts = mixedVideoAndNonVideoMessage;
    }
    return error;
  };

  /**
   * No errors as of now. Force the end date to the start date
   * If dates are missing altogether, make it today
   */
  validateDates = () => {
    const { placement } = this.state;
    if (!placement.start) {
      placement.start = moment().format('iso');
    }
    if (!placement.end) {
      placement.end = moment().format('iso');
    }
    if (moment(placement.start).isAfter(placement.end)) {
      placement.end = placement.start;
    }
  };

  validateLineItemType = () => {
    const error = {};
    const { placement } = this.state;
    if (!placement.Strategy || !placement.SalesProduct || !placement.IoRateTypeId) {
      return error;
    }
    const lineItemType = this.computeLineItemType(placement.Strategy, placement.SalesProduct);
    if (lineItemType === 'STANDARD' && placement.IoRateTypeId === 5) {
      error.IoRateTypeId = `Line Item Type is ${lineItemType} but must be SPONSORSHIP for Flat Fee going to Ad Manager`;
    }
    return error;
  };

  validateCustomTargeting = () => {
    const { placement } = this.state;
    placement.customTargetingArr = this.trimTargeting(placement.customTargetingArr);
    return {};
  };

  /**
   * Some strategy/sales product combinations require particular custom content targeting.
   * @returns {{}}
   */
  validateSpecialTargeting = (placement = this.state.placement) => {
    const errors = {};
    const strategyName = placement && placement.Strategy ? placement.Strategy.name : '';
    const salesProductName = placement && placement.SalesProduct ? placement.SalesProduct.name : '';
    const customTargetingArr = (placement && placement.customTargetingArr) || [];
    const customTargeting = customTargetingArr.map(cta => cta.map(ct => ct.type)).join();
    console.log(`VST custom targeting: ${customTargetingArr} ${strategyName}, ${salesProductName}`);
    if (strategyName === 'YouTube | Editorial Content Sponsorship') {
      const hasKvidValue = customTargetingArr.some(orClause =>
        (orClause || []).some(clause => clause.type === 'kvid' &&
          Array.isArray(clause.items) && clause.items.some(item => String(item.name || '').trim())));
      if (!hasKvidValue) {
        errors.SalesProductId = 'YouTube | Editorial Content Sponsorship requires kvid= targeting';
      }
    }
    if (strategyName === 'Custom Content' && salesProductName === 'CDRT Contextual') {
      if (!customTargeting.includes('content') && !customTargeting.includes('artid')) {
        errors.SalesProductId = `Custom Content with CDRT Contextual requires artid or content targeting`;
      }
    }
    if (salesProductName === 'MTR Newsletter'){
      if (!customTargeting.includes('content')) {
        errors.SalesProductId = `MTR Newsletter requires content= targeting`;
      }
    }
    if (strategyName === 'Custom Content' && salesProductName === 'HDM Inventory'){
      if (!customTargeting.includes('artid')) {
        errors.SalesProductId = `Custom Content with HDM Inventory requires artid= targeting`;
      }
    }
    if (strategyName === 'Vehicle Engagement Platform' && salesProductName === 'CDRT Contextual'){
      if (!customTargeting.includes('content')) {
        errors.SalesProductId = `Vehicle Engagement Platform with CDRT Contextual requires content= targeting`;
      }
    }
    if (strategyName === 'Vehicle Engagement Platform' && salesProductName === 'HDM Inventory'){
      if (!customTargeting.includes('artid')) {
        errors.SalesProductId = `Vehicle Engagement Platform with HDM Inventory requires artid= targeting`;
      }
    }
    if ((strategyName === 'HDM Landing Page 100%' && salesProductName === 'HDM Inventory') ||
      (strategyName === 'HDM LPTO-Topic FITO' && salesProductName === 'HDM Inventory')) {
      if (!customTargeting.includes('sect')) {
        errors.SalesProductId = `HDM Landing Page 100% with HDM Inventory requires sect= targeting`;
      }
    }
    if (strategyName === 'Consideration Boost Landing' && salesProductName === 'JAG Contextual'){
      if (!customTargeting.includes('jamtest')) {
        errors.SalesProductId = `Consideration Boost Landing with JAG Contextual requires jamtest= targeting`;
      }
    }
    if (strategyName === 'AURA IQ' && ['HDM Inventory', 'CDRT Contextual'].includes(salesProductName)) {
      if (!customTargeting.includes('hctx')) {
        errors.SalesProductId = `AURA IQ requires hctx= targeting`;
      }
    }
    if (strategyName === 'Editorial Content Sponsorship Roadblock' && salesProductName === 'HDM Inventory') {
        if (!customTargeting.includes('artid') &&
        !customTargeting.includes('clc') &&
        !customTargeting.includes('sect')) {
        errors.SalesProductId = `Editorial Content Sponsorship Roadblock with HDM Inventory requires artid, clc, or sect targeting`;
      }
    }
    if (strategyName === 'Editorial Content Sponsorship Roadblock' && salesProductName === 'CDRT Contextual') {
      if (!customTargeting.includes('artid') &&
        !customTargeting.includes('clc') &&
        !customTargeting.includes('sect') &&
        !customTargeting.includes('content')) {
        errors.SalesProductId = `Editorial Content Sponsorship Roadblock with CDRT Contextual requires artid, clc, content, or sect targeting`;
      }
    }
    if (strategyName === 'LLM Cobranded Content Sponsorship | Roadblock (US)' &&
      salesProductName === 'HDM Inventory') {
      if (!customTargeting.includes('artid') &&
        !customTargeting.includes('clc') &&
        !customTargeting.includes('sect')) {
        errors.SalesProductId = `LLM Cobranded Content Sponsorship | Roadblock (US) with HDM Inventory requires artid, clc, or sect targeting`;
      }
    }
    if (strategyName === 'LLM Cobranded Content Sponsorship | Roadblock (US)' &&
      salesProductName === 'CDRT Contextual') {
      if (!customTargeting.includes('content') &&
        !customTargeting.includes('artid') &&
        !customTargeting.includes('clc') &&
        !customTargeting.includes('sect')) {
        errors.SalesProductId = `LLM Cobranded Content Sponsorship | Roadblock (US) with CDRT Contextual requires content, artid, clc, or sect targeting`;
      }
    }
    if (errors && !isEmpty(errors)) {
      console.error(`Strategy/Sales Product errors ${salesProductName} ${strategyName}`, errors);
    }
    console.log('errors', errors.length);
    return errors;
  };

  validatePlacement = (placement) => {
    // console.log('validatePlacement ------------------', placement);
    const errors = {
      ...this.validateCreativeProducts(),
      ...this.validatePresets(),
      ...this.validatePubs(),
      ...this.validateLineItemType(),
      ...this.validateCustomTargeting(),
      ...this.validateSpecialTargeting(placement)
    };
    this.validateDates();
    Object.keys(this.placementValidationRules).forEach(field => {
      const err = validate(placement[field], this.placementValidationRules[field]);
      if (err) {
        errors[field] = err;
      }
    });
    console.log('errors', errors);
    return errors;
  };

  handleValidation = (value, name) => {
    const { errors: e } = this.state;
    const errors = Object.assign({}, e);
    const err = validate(value, this.placementValidationRules[name]);
    if (err) {
      errors[name] = err;
    } else {
      delete errors[name];
    }
    return errors;
  };

  amountChanged = evt => {
    const { placement } = this.state;
    const { constants } = this.props;
    const { name, value } = evt.target;
    let val = value;
    if (name !== 'IoRateTypeId') {
      if (value === '0' || value === '0.00') {
        val = '0';
      } else {
        val = value.replace( /[^0-9.]/g, '' ).replace(/^0+/, '')
      }
    }
    let ret = { total: 0, quantity: 0 }
    switch(name) {
      case 'contractedQuantity':
      ret = computeTotalContractAmount(val, placement.ioRate, placement.IoRateTypeId, placement.start, placement.end, placement.lineItemType);
        break;
      case 'ioRate':
      ret = computeTotalContractAmount(placement.contractedQuantity, val, placement.IoRateTypeId, placement.start, placement.end, placement.lineItemType);
        break;
      case 'IoRateTypeId':
      ret = computeTotalContractAmount(placement.contractedQuantity, placement.ioRate, val, placement.start, placement.end, placement.lineItemType);
        break;
      default:
        return;
    }
    const errors = this.handleValidation(val, name);
    placement[name] = val;
    if (name === 'IoRateTypeId') {
      placement.IoRateType = constants.ioRateTypes.find(iort => iort.id === val);
      if (value === 5) /* Flat Fee */ {
        placement.contractedQuantity = 1;
      }
    }
    placement.totalContractAmount = ret.total;
    placement.contractedQuantity = ret.quantity;
    this.setState({ placement, errors });
  };

  handleTargetingChange = (name, value, placement) => {
    const errors = this.handleValidation(value, name);
    placement.lineItemType = this.computeLineItemType(placement.Strategy, placement.SalesProduct);
    this.setState({ placement, errors });
  };

  handleExclusionsChange = (evt) => {
    const { placement } = this.state;
    placement.exclusions = evt.target.value;
    this.setState({ placement });
  }

  computeLineItemType = (strategy, salesProduct) => {
    const { constants } = this.props;
    if (!salesProduct || !strategy) {
      return 'STANDARD';
    }
    if (constants.spNotAdManager.includes(salesProduct.code)) {
      return 'NOT AD MANAGER';
    }
    if (salesProduct.name && salesProduct.name.slice(0, 2) === 'BM') {
      return 'SPONSORSHIP';
    }
    if (!strategy.name) {
      return 'STANDARD';
    }
    if (constants.stratSponsorship.includes(strategy.name)) {
      return 'SPONSORSHIP';
    }
    if (/100%/.test(strategy.name)) {
      return 'SPONSORSHIP';
    }
    return 'STANDARD';
  };

  /**
   * Handle most changes
   * Some fields need to be trimmed
   * Billing ID should be copied from placement id if not existing and different
   * Some changes calculate or clear other fields
   * @param evt
   */
  handleChange = evt => {
    const { placement: p } = this.state;
    const placement = Object.assign({}, p);
    const { name, value } = evt.target;
    const errors = this.handleValidation(value, name);
    let localValue = value;
    if (name === 'agencyPlacementId' || name === 'agencyBillingId') {
      localValue = localValue.trim();
    }
    if (name === 'agencyPlacementId' && placement.agencyPlacementId === placement.agencyBillingId) {
      placement.agencyBillingId = localValue;
    }
    if (name === 'start') {
      if (moment(value).isAfter(placement.end)) {
        placement.end = moment(value).endOf('month').add(-12, 'hours').format();
      }
      let ret = computeTotalContractAmount(placement.contractedQuantity, placement.ioRate, placement.IoRateTypeId, value, placement.end, placement.lineItemType);
      placement.totalContractAmount = ret.total;
      placement.contractedQuantity = ret.quantity;
    }
    if (name === 'end') {
      let ret = computeTotalContractAmount(placement.contractedQuantity, placement.ioRate, placement.IoRateTypeId, placement.start, value, placement.lineItemType);
      placement.totalContractAmount = ret.total;
      placement.contractedQuantity = ret.quantity;
    }
    if (name === 'SalesProductId') {
      placement.CreativeProducts = [];
    }
    if (name === 'genericTargeting') {
      this.manageGenericTargeting(placement, localValue);
    }
    if (name === 'geoGlobal') {
      placement.geoGlobal = !localValue.global;
      this.setState({ placement, errors });
      return;
    }
    if (name === 'Geotargets') {
      placement.Geotargets = localValue.geotargets;
      placement.excludedGeotargetIds = localValue.excludedGeotargetIds;
      placement.geogroups = localValue.geogroups;
    } else {
      placement[name] = localValue;
    }
    this.setState({ placement, errors });
  };

  /***
   * Remove "and" clauses with empty item lists, then remove "or" Clauses that are likewise empty
   * @param value
   * @returns {*}
   */
  trimTargeting = (value) => {
    try {
      console.log('trimTargeting', value);
      for (let orIndex = value.length - 1; orIndex >= 0; orIndex--) {
        const orClause = value[orIndex]
        console.log(value.length);
        for (let andIndex = orClause.length - 1; andIndex >= 0; andIndex--) {
          console.log(orIndex, andIndex);
          const andClause = orClause[andIndex]
          if (!andClause.items.length) {
            orClause.splice(andIndex, 1)
          }
        }
        if (!orClause.length) {
          value.splice(orIndex, 1)
        }
      }
    } catch (e) {
      console.log('caught error on trimTargeting', value);
      value = 0;
    }
    return value;
  }

  /**
   * Remove any empty targeting clauses, then represent the targeting in string form
   * @param placement
   * @param newValue
   */
  manageGenericTargeting = (placement, newValue) => {
    placement.customTargetingArr = JSON.parse(JSON.stringify(newValue));
    placement.customTargeting = '';
    const trimmed = this.trimTargeting(newValue);
    if (trimmed.length) {
      placement.customTargeting = trimmed.map(orClause => {
        return orClause.map(andClause => {
          const itemsList = andClause.items.map(item => item.name).join(',');
          if (andClause.qualifier === 'included') {
            return `${andClause.type}=${itemsList}`
          } else {
            return `!${andClause.type}=${itemsList}`
          }
        }).join(' AND ')
      }).join(' OR ')
    }
  }

  addError = err => {
    this.setState(prevState => ({
      errors: Object.assign({}, prevState.errors, err)
    }));
  };

  getGeoParents = () => {
    const { placement } = this.state;
    if (isEmpty(placement.Geotargets)) {
      return new Set([]);
    }
    const parentIds = placement.Geotargets.map(g => {
      if (g.parentIds && Array.isArray(g.parentIds)) {
        return g.parentIds.split(',');
      } else {
        return [];
      }
    })
    return new Set([].concat(...parentIds));
  };

  render() {
    const { placement, errors, innerHeight, pkg } = this.state;
    const {
      classes,
      order,
      constants,
      strategies,
      deviceTypes,
      salesProducts,
      creativeProducts,
      presets,
      tpts,
      error,
      itemRemainder,
      packageId,
      user,
      isReadOnly,
      ...rest
    } = this.props;

    if (placement) {
      placement.lineItemType = this.computeLineItemType(placement.Strategy, placement.SalesProduct);
      let ret = { total: 0, quantity: 0 }
      ret = computeTotalContractAmount(placement.contractedQuantity, placement.ioRate, placement.IoRateTypeId, placement.start, placement.end, placement.lineItemType);
      placement.totalContractAmount = ret.total;
      placement.contractedQuantity = ret.quantity;
    }
    const adManagerBlocks = placement && placement.LineItems ?
      placement.LineItems.map((li, index) => {
        const lsUser = localStorage.getItem('user');
        return <Grid item xs={12}>
          <AdManagerView
            key={index}
            variant={index + 1}
            placement={placement}
            constants={constants}
            user={lsUser}
          />
        </Grid>
      }) : '';

    return (
      <div>
        <TrackingCtx.Provider value={{category:"Placement Toolbar", label: `IO#${placement.IoId} Placement#${placement.id || ''}`   }}>
        <ErrorPage error={error} entity="placement">
          <PlacementToolbar
            isNew={!placement.id}
            {...rest}
            onSave={this.save}
            onSaveAndNew={this.saveAndNew}
            order={order}
            placement={placement}
            onNext={this.saveAndNext}
            onPrior={this.saveAndPrior}
            onDone={this.saveAndDone}
            isReadOnly={isReadOnly}
          />
          <div className={classes.root} style={{height: innerHeight - 160}}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <PlacementBasicForm
                  isNew={!placement.id}
                  errors={errors}
                  placement={placement}
                  order={order}
                  constants={constants}
                  onChange={this.handleChange}
                  itemRemainder={itemRemainder}
                />
              </Grid>

              <Grid item xs={12}>
                <Targeting
                  order={order}
                  placement={placement}
                  constants={constants}
                  strategies={strategies}
                  deviceTypes={deviceTypes}
                  salesProducts={salesProducts}
                  creativeProducts={creativeProducts}
                  presets={presets}
                  tpts={tpts}
                  pkg={pkg}
                  classes={classes.leftIcon}
                  errors={this.state.errors}
                  exclusions={this.state.placement.exclusions || []}
                  onChange={this.handleChange}
                  onError={this.addError}
                  onTargetingChange={this.handleTargetingChange}
                  onExclusionsChange={this.handleExclusionsChange}
                  itemRemainder={itemRemainder}
                />
              </Grid>

              <Grid item xs={12}>
                <RatesAndDates
                  order={order}
                  placement={placement}
                  constants={constants}
                  strategies={strategies}
                  salesProducts={salesProducts}
                  errors={errors}
                  pkg={pkg}
                  onAmountChange={this.amountChanged}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <Geotargets
                  parents={this.getGeoParents()}
                  geotargets={placement.Geotargets || []}
                  geoGlobal={placement.geoGlobal}
                  excludedGeotargetIds={placement.excludedGeotargetIds || []}
                  geogroups={placement.geogroups || []}
                  classes={classes.leftIcon}
                  onChange={this.handleChange}
                />
              </Grid>

              {adManagerBlocks}

            </Grid>
          </div>
        </ErrorPage>
      </TrackingCtx.Provider>
      </div>
    )
  }
}

PlacementPage.defaultProps = {
  placement: null,
  order: null,
  constants: null
};

PlacementPage.propTypes = {
  classes: PropTypes.object.isRequired,
  placement: PropTypes.object,
  constants: PropTypes.object,
  order: PropTypes.object,
};

export default withStyles(styles)(PlacementPage);
